module.exports = __webpack_public_path__ + "static/media/Grupo 333@2x.f7b89dba.png";